module.exports = __webpack_public_path__ + "static/img/medal2.862f566.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/2/medal2.png
// module id = vdsH
// module chunks = 1